import "../../styles/UserDashboard/SellEnergy.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import EnergyHeader from "../../components/energy/energyHeader";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";
import Web3 from "web3";
import { useForm } from "react-hook-form";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { lgaList } from "../../data/nigerianStatesData";

export default function SellEnergy() {
  const navigate = useNavigate();
  const [amount, setAmount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [account, setAccount] = useState(null);
  const [listing, setListing] = useState(null);
  const pathname = useParams();
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          alert(
            "Please allow access to your MetaMask wallet to enable you exchange your CCRT"
          );
          console.error("User denied account access", err);
        });
    } else {
      console.error(
        "MetaMask is not installed. Please install it to use this app."
      );
    }
  }, []);

  // const contractAddress = "0xeb575bf85F0E888d962A0116db7c142235B8d3E2";
  const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";


  const contractABI = EnergySharingContract.abi;

  const contract = web3
    ? new web3.eth.Contract(contractABI, contractAddress)
    : null;

  const handleInitiateTrade = async () => {
    console.log("Initiating demand trade...");
    setLoading(true);

    if (!amount || pathname?.id) {
      console.error("Missing required data: amount or demand ID");
      setLoading(false);
      return;
    }

    try {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      const tradeId = await integration.initiateDemandTrade(
        Number(pathname?.id),
        Number(amount)
      );

      console.log("Trade initiated successfully with ID:", tradeId);

      // Navigate to waiting page after successful trade initiation
      navigate("/waiting-for-buyer");

    } catch (error) {
      console.error("Failed to initiate demand trade:", error);
      // You might want to show an error message to the user here
      alert(`Trade initiation failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleGetListing = async () => {
    const integration = new EnergyTradingIntegration("seller");
    await integration.init();
    const response = await integration.getSellerListing(pathname?.id);
    setListing(response);
  };

  useEffect(() => {
    handleGetListing();
  }, []);

  const states = Object.keys(lgaList).sort();


  const onSubmit = (data) => {
    console.log("data", data);

    // setValues(data);
    // setStage(2);
  };

  return (
    <div className="sellEnergy">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="sellEnergy__inner">
        <EnergyHeader />

        <div className="sellEnergy__inner__card">
          <div className="sellEnergy__inner__card__header">
            <div className="sellEnergy__inner__card__header__user">
              <div className="sellEnergy__inner__card__header__user__icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                    stroke="#2C9963"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                    stroke="#2C9963"
                    stroke-width="2"
                  />
                </svg>
              </div>

              <div>
                <div className="sellEnergy__inner__card__header__user__title">
                  {listing?.location}
                </div>
                <div className="sellEnergy__inner__card__header__user__subtitle">
                  Location: <span>{listing?.location}</span>
                </div>
              </div>
            </div>

            <div className="sellEnergy__inner__card__header__rate">
              ₦{listing?.pricePerUnit} / kWh
            </div>
          </div>

          <form className="sellEnergy__inner__card__cards" onSubmit={handleSubmit(onSubmit)}>
            <div className="sellEnergy__inner__card__cards__card1">
              <label
                className="sellEnergy__inner__card__cards__label"
                htmlFor="
                "
              >
                Amount to sell
              </label>
              <div className="sellEnergy__inner__card__cards__card1__input">
                <div>kWh</div>
                <input
                  type="number"
                  placeholder="0.00"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <div className="pointer" onClick={() => setAmount(listing?.maxPurchaseAmount)}>
                  Max
                </div>
              </div>

              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>You are selling</div>
                <div>{amount || 0} kWh</div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Buyer limit</div>
                <div>
                  {listing?.minPurchaseAmount} - {listing?.maxPurchaseAmount}{" "}
                  kWh
                </div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Buyer will pay</div>
                <div>₦{Number(amount) * Number(listing?.pricePerUnit)}</div>
              </div>
            </div>
            <div className="sellEnergy__inner__card__cards__card2">
              <div className="sellEnergy__inner__card__cards__card2__input-group">
                <div>
                  <label
                    className="sellEnergy__inner__card__cards__label"
                    htmlFor=""
                  >
                    State
                  </label>
                  <select name="" id=""
                    {...register("stateOfOrigin")}
                  >
                    <option value="">Choose state</option>
                    {states?.map((item) => (
                      <option value={item}>{item}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label
                    className="sellEnergy__inner__card__cards__label"
                    htmlFor=""

                  >
                    House Number
                  </label>
                  <input type="text" placeholder="House number"
                    {...register("houseNumber")}
                  />
                </div>
              </div>

              <label
                className="sellEnergy__inner__card__cards__label"
                htmlFor=""
              >
                Address
              </label>
              <input type="text" placeholder="Address"
                {...register("address")}
              />

              <div className="sellEnergy__inner__card__cards__card2__terms">
                <input type="checkbox" name="" id="" />
                <div>
                  I agree to the <a href="">Terms of Service</a>
                </div>
              </div>

              <button
                type="button"
                onClick={handleInitiateTrade}
                disabled={loading || !amount}
              >
                {loading ? "Processing..." : "Proceed To Sell"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
